module.exports = __webpack_public_path__ + "static/media/timeline-1.cca7aa32.png";